<template>
  <span class="sort-data">
    <el-button class="do-btn-four" type="default" icon="el-icon-view" @click="openDialog">字段显示</el-button>
    <!-- 设置树结构 -->
    <new-dialog
      class="sord-modal"
      :newModalVisible="modalVisible"
      @closeNewTask="closeImport"
      modalTitle="字段显示"
    >
      <div slot="content">
        <el-table class="fields-table" :data="cpTabelData" border stripe>
          <el-table-column prop="column" label="显示字段"></el-table-column>
          <el-table-column width="80px" label="是否显示">
            <template slot-scope="{row}">
              <el-checkbox v-model="row.isChecked"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column width="80px" label="显示顺序">
            <template slot-scope="scope">
              <div class="table-do-btn">
                <el-button
                  icon="el-icon-d-arrow-left"
                  @click="moveUp(scope.$index)"
                  style="height:auto;width:auto"
                ></el-button>
                <el-button
                  icon="el-icon-d-arrow-right"
                  @click="moveDown(scope.$index)"
                  style="height:auto;width:auto"
                ></el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <template v-slot:footer>
        <el-button class="modal-footer-two" @click="cancel">取消</el-button>
        <el-button class="modal-footer-two" type="primary" @click="comfirm">保存</el-button>
      </template>
    </new-dialog>
  </span>
</template>

<script>
import { cloneDeep } from "lodash";
import newDialog from "../new-dialog/index";
import Sortable from "sortablejs";
import { setStore, getStore } from "@/utils/store";

export default {
  components: {
    newDialog
  },
  props: {
    tableRow: {
      type: Array,
      default: () => []
    },
    sessionOriginalName: {
      type: String,
      default: ""
    },
    sessionResultName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      modalVisible: false,
      cpTabelData: []
    };
  },
  mounted() {
    this.getData();
  },
  watch: {
    tableRow() {
      this.cpTabelData = this.dataResolve(this.tableRow);
    }
  },
  methods: {
    getData() {
      if (this.sessionOriginalName) {
        const tableData = getStore({
          name: this.sessionOriginalName,
          type: "session"
        });
        if (tableData && tableData.length) {
          return (this.cpTabelData = cloneDeep(tableData));
        }
      }
      // console.log("数据", this.tableRow);
      this.cpTabelData = this.dataResolve(this.tableRow);
    },
    openDialog() {
      this.modalVisible = true;
      this.$nextTick(() => {
        this.initSortabel();
      });
    },
    dataResolve(list) {
      const cpList = cloneDeep(list);
      return cpList.map(el => {
        return {
          isChecked: true,
          ...el
        };
      });
    },
    closeImport() {
      this.cancel()
      // this.modalVisible = false;
    },
    comfirm() {
      // console.log(this.cpTabelData);
      setStore({
        name: this.sessionOriginalName,
        content: this.cpTabelData,
        type: "session"
      });
      const resovleList = this.cpTabelData.filter(el => {
        return el.isChecked;
      });
      setStore({
        name: this.sessionResultName,
        content: resovleList,
        type: "session"
      });
      this.modalVisible = false;
      this.$emit("showList", resovleList);
    },
    cancel() {
      this.getData();
      this.modalVisible = false;
    },
    moveUp(index) {
      if (index > 0) {
        let upDate = this.cpTabelData[index - 1];
        this.cpTabelData.splice(index - 1, 1);
        this.cpTabelData.splice(index, 0, upDate);
      } else {
        this.$message.warning("已经是第一条，不可上移");
      }
    },
    moveDown(index) {
      if (index + 1 === this.cpTabelData.length) {
        this.$message.warning("已经是最后一条，不可下移");
      } else {
        const downDate = this.cpTabelData[index + 1];
        this.cpTabelData.splice(index + 1, 1);
        this.cpTabelData.splice(index, 0, downDate);
      }
    },
    initSortabel() {
      const el = document.querySelector(".fields-table .el-table__body tbody");
      const Vm = this;
      Vm.sortable = new Sortable(el, {
        animation: 300,
        onEnd(evt) {
          // 拖拽结束发生该事件
          Vm.cpTabelData.splice(
            evt.newIndex,
            0,
            Vm.cpTabelData.splice(evt.oldIndex, 1)[0]
          );
          const newArray = Vm.cpTabelData.slice(0);
          Vm.cpTabelData = [];
          Vm.$nextTick(() => {
            Vm.cpTabelData = newArray;
          });
        }
      });
    }
  }
};
</script>

<style lang='scss'>
.sort-data {
    display: inline-block;
    vertical-align: top;
}
</style>
